/**
 * Theme colors
 */
const colors = {
  transparent: 'transparent',
  black: '#000000',
  white: '#FFFFFF',
  primary: '#0B64CC',
  secondary: {
    critical: '#DF1414',
    criticalHover: '#B21010',
    warning: '#B98900',
    success: '#009444',
    informative: '#00A0AC',
    gray: '#EDF2F7',
    caution: '#FF8A00',
  },
  text: {
    default: '#1A1A1A',
    secondary: '#323741',
    filler: '#A3AEBE',
    critical: '#D72C0D',
    success: '#045D39',
  },
  overlay: {
    primary: {
      20: '#084FA3',
    },
    secondary: {
      critical: { 20: '#B21010' },
      warning: { 20: '#946D00' },
      success: { 20: '#2C644E' },
      informative: { 20: '#008089' },
      gray: { 20: '#E2E8F0' },
    },
    dark: {
      50: '#00000080',
      20: '#00000033',
    },
  },
  texticon: {
    default: '#1A1A1A',
    white: '#FFFFFF',
    filler: '#A3AEBE',
    secondary: '#718096',
    critical: '#DF1414',
    warning: '#B98900',
    success: '#045D39',
    informative: '#005F66',
    gray: '#1A1A1A',
  },
  background: {
    white: '#FFFFFF',
    grey: '#F8F8F9',
    interactive: '#F2F7FE',
    critical: '#FFF4F4',
    warning: '#FFF5EA',
    success: '#F1F8F5',
    informative: '#EBF9FC',
    gray: '#EDF2F7',
    grayHover: '#CDD5DF',
  },
  border: {
    default: '#8C9196',
    secondary: '#C9CCCF',
    input: '#E3E8EF',
    critical: '#E0B3B2',
    warning: '#E1B878',
    success: '#95C9B4',
    informative: '#98C6CD',
    gray: '#E2E8F0',
  },
  badge: {
    completed: '#EEEEEE',
    approved: '#D9F1F8',
    pending: '#FFF0BC',
    rejected: '#FFE7DF',
    expired: '#FFE7DF',
    expiring: '#FFEBD4',
    active: '#C6F6D5',
    inactive: '#FFF4F4',
  },
  alerticon: {
    success: '#009444',
  },
};

export default colors;
